import icsChromelyRequest from '@icreate/ics-chromely-js-sdk'
import IndexExamine from './index-examine'
import { escapeSpecialCharacters } from './utils'

export default class Icd10Index {
  private static like = ['ID', 'NAME', 'SPELL_CODE', 'STROKE_CODE']
  /**
   * 查询icd10诊断
   * @param keys：关键字
   * @param category 诊断类别  11：疾病诊断 12：损伤中毒原因 13：肿瘤形态学(对应病案首页病理诊断)
   * @returns 成功返回结果
   */
  public static query(category: string, keys: string = ''): Promise<any> {
    if (icsChromelyRequest.isChromely) {
      return IndexExamine.query(
        'Icd10Index',
        category,
        this.QueryCondition(category, escapeSpecialCharacters(keys))
      )
    } else {
      return IndexExamine.queryByServer('Icd10Index', category, keys, this.like, {})
    }
  }

  /**
   * 分页查询索引
   * @param indexId: 索引id
   * @param pageIndex：page索引
   * @param pageSize：page尺寸
   * @param category 诊断类别  11：疾病诊断 12：损伤中毒原因 13：肿瘤形态学(对应病案首页病理诊断)
   * @param keys：关键字
   * @returns 成功返回结果
   */
  public static page(
    pageIndex: number,
    pageSize: number,
    category: string,
    keys: string = ''
  ): Promise<any> {
    if (icsChromelyRequest.isChromely) {
      return IndexExamine.page(
        'Icd10Index',
        pageIndex,
        pageSize,
        category,
        this.QueryCondition(category, escapeSpecialCharacters(keys))
      )
    } else {
      return IndexExamine.pageByServer(
        'Icd10Index',
        pageIndex,
        pageSize,
        category,
        keys,
        this.like,
        {}
      )
    }
  }

  /**
   * 查询条件组装
   * @param keys
   * @returns
   */
  private static QueryCondition(category: string, keys: string): string {
    return `(id:*${keys}* OR name:"*${keys}*" OR spellCode:*${keys}* OR strokeCode:*${keys}*)`
  }
}
